








import Method from './Method.vue';
import {
  anchorKinds,
  createObserverHelper,
  ObserverParameters,
  unobserveHelper,
  uppercaseKinds,
} from '@/heplers';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { Mutation, State } from 'vuex-class';
import { StoreMutations } from '@/templates/DataNames';

@Component({
  components: {
    Method,
  },
  filters: {
    capitalizeName: (name: string) => {
      return uppercaseKinds[name];
    },
  },
})
export default class Parse extends Vue {
  @Prop(Array) data: any;
  @Prop(String) name: string;
  @State pageRendered: boolean;
  @State currentAnchor: string;
  @State toggleListeners: boolean;
  @Mutation(StoreMutations.SET_CURRENT_ANCHOR) setAnchor: (anchor: string) => void;

  private observerParams: ObserverParameters | Record<string, never> = {};
  private createObserver = createObserverHelper;
  public currentRole = 'All Roles';
  private visibleMethodsOrder: IntersectionObserverEntry[] = [];
  private unobserve: () => void;

  get checkAnchorKinds() {
    return anchorKinds.includes(this.name);
  }

  @Watch('pageRendered')
  onPageRenderedChange(val: boolean) {
    if (val) this.initObserver();
  }

  // ПРи каждом изменении данных обновляем observer
  @Watch('data')
  onChangeData() {
    this.initObserver();
  }

  @Watch('toggleListeners')
  onChangeListeners(bool: boolean) {
    bool ? unobserveHelper(this.observerParams) : this.initObserver();
  }

  mounted() {
    this.initObserver();
  }

  initObserver() {
    if (this.unobserve) {
      this.unobserve();
    }

    this.$nextTick(() => {
      this.observerParams = {
        selectors: document.querySelectorAll('div.method'),
        options: {
          threshold: 0.05,
          rootMargin: '-10% 0px -10% 0px',
        },
        resultFunction: this.findAnchor,
        context: this,
      };

      this.unobserve = this.createObserver(this.observerParams);
    });
  }

  private updateVisibleElementsOrder(entry: IntersectionObserverEntry) {
    const { isIntersecting, target } = entry;

    if (!isIntersecting) {
      this.visibleMethodsOrder = this.visibleMethodsOrder.filter(
        (method) => method.target.id !== target.id
      );
      return;
    }

    const targetOffsetTop = (target as HTMLElement).offsetTop;
    const lastElement = this.visibleMethodsOrder.at(-1);
    const lastOffsetTop = lastElement ? (lastElement.target as HTMLElement).offsetTop : -1;

    if (lastOffsetTop <= targetOffsetTop) {
      this.visibleMethodsOrder.push(entry);
    } else {
      this.visibleMethodsOrder.unshift(entry);
    }
  }

  private findAnchor(entry: IntersectionObserverEntry) {
    this.updateVisibleElementsOrder(entry);

    const firstVisible = this.visibleMethodsOrder[0];
    if (!firstVisible) {
      this.setWindowHash('');
      return;
    }

    // Если сейчас идет скролл, то мы меняем хеш на тот, к которому скроллимся, и не выполняем остальное
    if (!this.toggleListeners) {
      this.setWindowHash(this.currentAnchor);
      return;
    }

    this.setAnchor(firstVisible.target.id);

    if (
      this.pageRendered &&
      document.getElementById('layout')?.scrollTop !== 0 &&
      typeof window.history.replaceState == 'function'
    ) {
      this.setWindowHash(firstVisible.target.id);
    }
  }

  private setWindowHash(hash: string) {
    const url = new URL(window.location.href);
    url.hash = hash;
    history.replaceState('', document.title, url);
  }
}
